import constants from '../constants/index';

const MeetingLayerActions = {
    
  selectMeetingLayer: function(id, selected) {
    return {
      type: constants.SELECT_MEETING_LAYER,
      payload: {
        id: id,
        selected: selected
      }
    }
  }
  
};

export default MeetingLayerActions;


/** WEBPACK FOOTER **
 ** ./src/js/actions/meeting_layer_actions.js
 **/